<template>
  <div class="memorandums-page my-3">
    <div class="page-head card shadow-sm border-0 mb-3">
      <div class="card-body d-flex align-items-center">
        <span class="head-icon">
          <i class="bi bi-journal-text"></i>
        </span>
        <div>
          <h4 class="font-weight-bold mb-0">Regional Memorandums</h4>
          <p class="page-subtitle mb-0">
            Browse issued CHED Caraga memorandums and access their soft copies.
          </p>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <RegionalMemos />
      </div>
    </div>
  </div>
</template>

<script>
import RegionalMemos from "./components/RegionalMemos.vue";

export default {
  name: "Memorandums",
  components: {
    RegionalMemos,
  },
};
</script>

<style scoped>
.page-head {
  border-radius: 14px !important;
}

.head-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(77, 141, 255, 0.12);
  color: #4d8dff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  margin-right: 1rem;
  flex-shrink: 0;
}

.page-subtitle {
  color: #768192;
  font-size: 0.9rem;
  margin-top: 0.15rem;
}

.card {
  border-radius: 14px !important;
}
</style>
